export const fontFamily = '"Lausanne", "Helvetica Neue", Arial, sans-serif'
